import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";

//import constants
import { PERMISSIONS } from "../../../constants/permissions";

//import images and icons
import logoImage from "../../../assets/imgs/logo-green.png";
import sibAppImage from "../../../assets/imgs/sib-app.png";
import cofeBazzarImage from "../../../assets/imgs/coffe-bazzar.png";
import googlePlayImage from "../../../assets/imgs/google-play.png";
import { Instagram } from "iconsax-react";

//import styles
import "./footer.scss";

export default function Footer() {
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    const miras = () => {
        window.open(`/${locale}/miras`, "_blank", "noopener,noreferrer");
    };

    return (
        <Grid className="footer" component="footer" container item xs={12} justifyContent="space-between" mt={-8}>
            <Grid className="footer__permissions" container item md={5} rowGap={0}>
                <span className="footer__title">{t("licensesTitle")}</span>
                <Grid className="footer__permissions-icons" container item xs={12} columnGap={0}>
                    {PERMISSIONS.map(permission => {
                        return (
                            <Grid key={permission?.name} container item xs={4} sm={3} lg={1.5} justifyContent="center" alignItems="center">
                                <a referrerPolicy="origin" target="_blank" href={permission?.href}>
                                    <img
                                        referrerPolicy="origin"
                                        src={permission?.src}
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                        id="tharoDr5MrfjIyvDSPJD"
                                    ></img>
                                </a>
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>

            <Grid className="footer__section" container item md={2.25} justifyContent="space-between">
                <Grid className="footer__title" container item xs={5} alignItems="center">
                    {t("downloadApp")}
                </Grid>
                <Grid className="footer__app-store" container item xs={6} rowGap={1} justifyContent="center">
                    {[
                        { name: "cafebazaar", href: "https://cafebazaar.ir/app/ir.atripa.twa", src: cofeBazzarImage },
                        { name: "googlePlay", href: "https://play.google.com/store/apps/details?id=com.atripa.app", src: googlePlayImage },
                        { name: "sibApp", href: "https://sibapp.com/applications/Atripa", src: sibAppImage },
                    ].map(store => {
                        return (
                            <a key={store?.name} target="_blank" href={store.href}>
                                <Grid component="img" src={store.src} container item xs={12} />
                            </a>
                        );
                    })}
                </Grid>
            </Grid>

            <Grid className="footer__section" container item md={4.25} alignItems="center">
                <Grid container item md={8} rowGap={0.5}>
                    <Grid className="footer__title" container item xs={12}>
                        {t("support")}:
                    </Grid>
                    <Grid container item xs={12} columnGap={1}>
                        <a className="footer__phone-number" href="tel: +989154017661">
                            {t("phoneNumber2")}
                        </a>
                        -
                        <a className="footer__phone-number" href="tel: +985136572582">
                            {t("phoneNumber3")}
                        </a>
                    </Grid>
                    <Grid className="footer__title" container item xs={12}>
                        {t("address")}:
                    </Grid>
                    <Grid className="footer__address" container item xs={12}>
                        {t("mashhadAddress")}
                    </Grid>
                    <Grid container item xs={12}>
                        <a target="_blank" href="https://www.instagram.com/atripa.ir?igsh=MW1ub2lmNTE1ZGN0cA==">
                            <Instagram size="24" color="var(--teal-color-18)" />
                        </a>
                    </Grid>
                </Grid>

                <Grid container item md={4} rowGap={1} direction="column" justifyContent="center" alignItems="center">
                    <img className="footer__logo-img" src={logoImage} alt="" />
                    <span className="footer__tamerlin-span">{t("advanceTripByAI")}</span>
                </Grid>
            </Grid>
        </Grid>
    );
}
